import * as Html from "../util/Html.ts";
export {init}
Html.registerWidget('widget/img-loader',{init:init})

function init(obj){
  //if the image is already loaded the onload will not be triggerred
  if(!obj.get(0).complete){
    var height = obj.height(); 
    //do not increase image size
    obj.css('width',obj.data('width')+'px');
    //calculate image height for current width
    obj.css('height',obj.width() * obj.data('height')/obj.data('width')+'px');
    obj.trigger('afterupdate',obj.height()-height);
    //remove height when loaded so resize will be good
    obj.on('load',function(){
      obj.css('width','auto');
      obj.css('height','auto');
    });  
  }
}